import { mapState, mapActions } from 'vuex'
import cardCompetition from '@/components/cards/card-competition/card-competition.vue'
import { find } from 'lodash'
import spinner from '@/components/common/spinner/spinner.vue'
import pagination from '@/components/common/pagination/pagination.vue'

export default {
  components: {
    cardCompetition,
    spinner,
    pagination
  },
  props: ['type'],
  data() {
    return {
      competitionsByType: [],
      competitionsLimit: 6
    }
  },
  watch: {
    searchedText: function () {
      this.searchAllStatuses()
    }
  },
  computed: {
    ...mapState('user', ['currentUser']),
    ...mapState('competition', ['searchedText']),
    userJSON() {
      return JSON.stringify(this.currentUser, null, 2)
    }
  },
  methods: {
    ...mapActions('competition', ['getCompetitions']),
    searchByStatus: async function (status, page) {
      const competitionType = find(this.competitionsByType, { name: status })
      try {
        competitionType.isLoading = true
        competitionType.competitions = await this.getCompetitions({
          page,
          status,
          limit: this.competitionsLimit,
          search: this.searchedText
        })
        competitionType.isLoading = false
      } catch (e) {
        competitionType.isLoading = false
        throw e
      }
    },
    onPageChange: function ({ page, additionalData }) {
      this.searchByStatus(additionalData.competitionStatus, page)
    },
    searchAllStatuses: function () {
      this.competitionsByType.forEach((competitionType) => {
        this.searchByStatus(competitionType.name, 1)
      })
    }
  },
  created() {
    if (this.type === 'active') {
      this.competitionsByType = [
        {
          name: 'ready',
          title: 'Ready & Pending',
          competitions: [],
          isLoading: false
        },
        {
          name: 'active',
          title: 'Live',
          competitions: [],
          isLoading: false
        },
        {
          name: 'completed',
          title: 'Completed',
          competitions: [],
          isLoading: false
        }
      ]
    } else {
      this.competitionsByType = [
        {
          name: 'closed',
          title: 'Closed',
          competitions: [],
          isLoading: false
        },
        {
          name: 'archived',
          title: 'Archived',
          competitions: [],
          isLoading: false
        }
      ]
    }
    this.searchAllStatuses()
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/dashboard/dashboard.js